import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  notification,
  Form,
  Select,
  Input,
  Divider,
} from "antd";
import styles from "./YourPlan.module.scss";
import commonStyles from "../../../TripSummary/ServiceSummary/ServiceSummaryComponent.module.scss";
import PlanCard from "../../../Shared/PlanCard";
import CreditCardForm from "../../../Shared/CreditCardForm/CreditCardForm";
import { useTripsCtx } from "../../../../context/TripDetailsContext";
import { useTripActions } from "../../../../hooks/useTripActions";
import moment from "moment";
import {
  selectDropdownArrowIcon,
  wandaPlusIcon,
} from "../../../../assets/images";
import DashBoardTable from "../../DashBoardTable";
import CollapsibleTrips from "../../../Shared/CollapsibleTrips/CollapsibleTrips";
import { ITripDetails } from "../../../ServiceUsers/Interfaces/ITripDetails";
import { usePlanDetailsCtx } from "../../../../context/PlanDetailsContext";
import { useCreditCardActions } from "../../../../hooks/useCreditCardActions";
import { usePaymentDetailsCtx } from "../../../../context/PaymentDetailsContext";
import {
  EmailNotificationValues,
  NotificationWandaBasic,
  NotificationWandaBasicService,
  TriggerEventId,
} from "../../../../types/EmailNotificationType";
import { sendEmailWandaPlusDowngrade } from "../../../../services/EmailNotificationService";
import { TTripAddress } from "../../../../types/TripTypes";
import { TrackAnalytics } from "../../../../types/ApplicationTypes";
import { useSubscriptionActions } from "../../../../hooks/useSubscriptionActions";
import emailWandaPlusSubscription from "../../../../helpers/emailWandaPlusSubscription";
import { cancelSubscriptionPlan } from "../../../../services/PaymentService/PaymentSubscriptionService";
import { usePersonSummaryCtx } from "../../../../context/PersonSummaryContext";
import {
  CancelSubscriptionReasons,
  LookupListItems,
  PaymentSubscriptionStatus,
} from "../../../../types/SubscriptionTypes";
import { Tabs } from "../../../../types/TripPaginationFilterTypes";
import { usePaginationCtx } from "../../../../context/PaginationContext";
import getCreditCardKindIcon from "../../../../helpers/getCreditCardKindIcon";
import crossMark from "../../../../assets/images/CrossMark.png";
import { formatUTCtoLocalDate } from "../../../../helpers/dateFormatters";

const YourPlan = () => {
  const [isChangePlanModalVisible, setIsChangePlanModalVisible] = useState<
    boolean
  >(false);
  const [isUseSavedCCModalVisible, setIsUseSavedCCModalVisible] = useState<
    boolean
  >(false);
  const [isUpgradePlanVisible, setIsUpgradePlanVisible] = useState<boolean>(
    false
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { TextArea } = Input;
  const [
    isCancelSubscriptionModalVisible,
    setIsCancelSubscriptionModalVisible,
  ] = useState<boolean>(false);
  const [
    isCancelledSubscriptionModalVisible,
    setIsCancelledSubscriptionModalVisible,
  ] = useState<boolean>(false);

  const [form] = Form.useForm();

  const {
    saveCreditCard,
    creditCardFormRef,
    isValidCCState,
    validateAndCheckForm,
    shouldDisableButton,
    resetFormAndSetDefaults,
    validateCreditCardByPaymentInstrumentId,
  } = useCreditCardActions(form);

  const { subscribeToWandaPlus } = useSubscriptionActions();

  const {
    getDefaultSavedCreditCard,
    isDefaultSavedCreditCardExists,
    defaultSavedCreditCardDetails: defaultCreditCard,
  } = usePaymentDetailsCtx();

  const { cancelTrip } = useTripActions();

  const { wandaOrgId } = useTripsCtx();

  const { forceRefetchCtx } = usePaginationCtx();
  const [, setForceRefetch] = forceRefetchCtx;

  const { caregiverSummaryInfo } = usePersonSummaryCtx();

  const {
    currentPlan,
    selectedPlanCtx,
    welcomeWandaPlusModalCtx,
    tripDetailsInfo,
    currentPlanDetails,
    isPlusPlanExpired,
    tripsAfterSubscriptionDateCtx,
    subscriptionCancellationReasons,
    getCurrentSubscriptionPlanDetails,
  } = usePlanDetailsCtx();

  const [selectedPlan, setSelectedPlan] = selectedPlanCtx;
  const [tripsAfterSubscriptionDate] = tripsAfterSubscriptionDateCtx;
  const [
    isWelcomeWandaPlusVisible,
    setIsWelcomeWandaPlusVisible,
  ] = welcomeWandaPlusModalCtx;
  const [isCancelReasonOther, setCancelReasonOther] = useState<boolean>(false);
  const [cancelReasonId, setCancelReasonId] = useState<number>(0);
  const [isCancelDisableButton, setIsCancelDisableButton] = useState<boolean>(
    true
  );

  const handleUpgradeAndChangePlan = (): void =>
    setIsChangePlanModalVisible(true);
  const handleCardClick = (plan: string): void => setSelectedPlan(plan);

  const handleCancelSubscription = async () => {
    try {
      if (
        tripsAfterSubscriptionDate.length > 0 ||
        tripsAfterSubscriptionDate.length === 0
      ) {
        setIsLoading(true);
        let emailServiceList: NotificationWandaBasicService[] = [];
        if (tripsAfterSubscriptionDate.length > 0) {
          const separatedData: Record<
            string,
            ITripDetails[]
          > = tripsAfterSubscriptionDate.reduce(
            (acc: Record<string, ITripDetails[]>, trip: ITripDetails) => {
              const { requestAssignmentId } = trip;
              !acc[requestAssignmentId] && (acc[requestAssignmentId] = []);
              acc[requestAssignmentId].push(trip);
              return acc;
            },
            {}
          );
          Object.entries(separatedData).forEach(
            ([requestAssignmentId, trips]) => {
              cancelTrip(trips[0], true);

              trips?.forEach((trip: ITripDetails) => {
                let pickuptime = trip.isWillCall
                  ? "Call when ready"
                  : moment(trip.appointmentTime || trip.requestPickTime).format(
                      "hh:mm A"
                    );

                let pickupAddressDetails: TTripAddress = {
                  address1: trip.pickUpAddress1,
                  address2: trip.pickUpAddress2,
                  city: trip.pickUpCity,
                  state: trip.pickUpState,
                  zip: String(trip.pickUpZipCode),
                };
                let dropOffAddressDetails: TTripAddress = {
                  address1: trip.dropOffAddress1,
                  address2: trip.dropOffAddress2,
                  city: trip.dropOffCity,
                  state: trip.dropOffState,
                  zip: String(trip.dropOffZipCode),
                };

                let notificationBasicService: NotificationWandaBasicService = {
                  bookingId: trip.bookingId,
                  dropOffAddress: addressDisplay(dropOffAddressDetails),
                  dropOffInstructions: trip.dropNotes,
                  pickupAddress: addressDisplay(pickupAddressDetails),
                  pickupInstructions: trip.pickupNotes,
                  pickupTime: pickuptime,
                  serviceId: trip.tripId,
                  serviceUserPersonId: trip.personId,
                };
                emailServiceList.push(notificationBasicService);
              });
            }
          );
        }
        const cancelReason = subscriptionCancellationReasons?.find(
          (reason: LookupListItems) => reason.value === cancelReasonId
        )?.label;
        await cancelSubscriptionPlan(
          currentPlanDetails.paymentSubscriptionId,
          cancelReasonId,
          cancelReason === CancelSubscriptionReasons.Other
            ? form.getFieldValue("notes")
            : undefined
        );
        await getCurrentSubscriptionPlanDetails();
        setIsCancelSubscriptionModalVisible(false);
        setIsCancelledSubscriptionModalVisible(true);
        emailWandaDowngrade(emailServiceList);
      }
    } catch (error: any) {
      notification.error({
        message: `Error ${error?.response?.status}`,
        description: error?.response?.statusText,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const emailWandaDowngrade = async (trip: NotificationWandaBasicService[]) => {
    let emailWandaBasic: NotificationWandaBasic = {
      eventId: TriggerEventId.WandaBasicSubscription,
      caregiverName: caregiverSummaryInfo.firstName,
      customerServicePhone: tripDetailsInfo.wandaCustomerCareNumber,
      organizationId: wandaOrgId.privatePayId,
      personId: caregiverSummaryInfo.personId,
      serviceType: EmailNotificationValues.ServiceType,
      subscriptionEndDate: formatUTCtoLocalDate(
        currentPlanDetails?.validUntil,
        "MM/DD/YYYY"
      ),
      services: trip?.length > 0 ? trip : null,
    };
    await sendEmailWandaPlusDowngrade(emailWandaBasic);
  };

  const addressDisplay = (address: TTripAddress): string => {
    const { address1, address2, city, state, zip } = address;
    const finalAddress =
      address1 && address2
        ? [`${address1} ${address2}`, city, state, zip]
        : [address1, city, state, zip];
    const fullAddress = finalAddress.filter(Boolean).join(", ");
    return fullAddress || "";
  };

  const handleConfirm = (): void => {
    if (selectedPlan === "Basic") {
      setIsCancelSubscriptionModalVisible(true);
      TrackAnalytics(
        "/DashBoard",
        "Service User setup subscription selection",
        "Plan Modal"
      );
    } else {
      isDefaultSavedCreditCardExists
        ? setIsUseSavedCCModalVisible(true)
        : setIsUpgradePlanVisible(true);
    }
    setIsChangePlanModalVisible(false);
  };

  const handleCancel = (modalBtn?: string) => {
    if (modalBtn === "NoTakeMeBack") {
      setIsCancelSubscriptionModalVisible(false);
      setIsChangePlanModalVisible(true);
    } else if (modalBtn === "changePlan") {
      setIsChangePlanModalVisible(false);
      setSelectedPlan(currentPlan);
    } else if (modalBtn === "creditCardForm") {
      resetFormAndSetDefaults();
      setIsUpgradePlanVisible(false);
      isDefaultSavedCreditCardExists
        ? setIsUseSavedCCModalVisible(true)
        : setIsChangePlanModalVisible(true);
    }
  };

  const handleUseDifferentCard = () => {
    setIsUseSavedCCModalVisible(false);
    setIsUpgradePlanVisible(true);
  };

  const handleUpgradePlus = async (modeOfPayment?: string) => {
    try {
      setIsLoading(true);
      let paymentInstrumentId;
      if (modeOfPayment !== "SavedCard") {
        const ccDetails = await saveCreditCard(true);
        paymentInstrumentId = ccDetails.paymentInstrumentId;
      } else {
        const isValidCreditCard = await validateCreditCardByPaymentInstrumentId(
          defaultCreditCard.paymentInstrumentId
        );
        if (!isValidCreditCard) {
          throw new Error();
        }
        paymentInstrumentId = defaultCreditCard.paymentInstrumentId;
      }

      await subscribeToWandaPlus(paymentInstrumentId);
      // set time out for phase-1, since its taking time to process transaction(handled in backend)
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const [{ renewOn }] = await getCurrentSubscriptionPlanDetails();

      emailWandaPlusSubscription(
        caregiverSummaryInfo.personId,
        caregiverSummaryInfo.firstName,
        wandaOrgId.privatePayId,
        tripDetailsInfo.wandaSubscriptionCost,
        renewOn
      );

      resetFormAndSetDefaults();
      setIsUseSavedCCModalVisible(false);
      setIsUpgradePlanVisible(false);
      setIsWelcomeWandaPlusVisible(true);
      TrackAnalytics(
        "/DashBoard",
        "Service User setup subscription selection",
        "Plan Modal"
      );
    } catch (error) {
      // already displaying the invalid CC error message on form
      modeOfPayment === "SavedCard" &&
        notification.error({
          message: "Error Processing the Credit Card",
          description: "Please try again or use a different card.",
        });
    } finally {
      setIsLoading(false);
    }
  };

  const handleLetsGo = async () => {
    try {
      getDefaultSavedCreditCard();
      setIsWelcomeWandaPlusVisible(false);
    } catch (error: any) {
      notification.error({
        message: `Error ${error.response.status}`,
        description: error?.response?.statusText,
      });
    }
  };

  const handleClose = () => {
    setIsCancelledSubscriptionModalVisible(false);
    setForceRefetch((prev: { [tab: string]: boolean }) => ({
      ...prev,
      [Tabs.UPCOMING]: !prev[Tabs.UPCOMING],
    }));
  };

  const handleCloseUseSavedCCModal = () => {
    setIsUseSavedCCModalVisible(false);
    setIsChangePlanModalVisible(true);
  };

  const renderWandaPlusDates = () => {
    switch (currentPlanDetails.paymentSubscriptionStatusId) {
      case PaymentSubscriptionStatus.Active:
        return (
          <Row justify="space-between">
            <Col span={14} className={styles.wandaPlusRenewalText}>
              Renews
            </Col>
            <Col span={10} className={styles.wandaPlusDateText}>
              {formatUTCtoLocalDate(currentPlanDetails?.renewOn, "MM/DD/YYYY")}
            </Col>
          </Row>
        );

      case PaymentSubscriptionStatus.Cancelled:
        return (
          <Row justify="space-between">
            <Col span={14} className={styles.wandaPlusRenewalText}>
              Expires
            </Col>
            <Col span={10} className={styles.wandaPlusDateText}>
              {formatUTCtoLocalDate(
                currentPlanDetails?.expiresOn,
                "MM/DD/YYYY"
              )}
            </Col>
          </Row>
        );
      default:
        return null;
    }
  };
  const handleValuesChange = () => {
    const cancelReasonId = form.getFieldValue("cancelReason");
    const comments = form.getFieldValue("notes");
    const reason = subscriptionCancellationReasons?.find(
      (reason: LookupListItems) => reason.value === cancelReasonId
    )?.label;
    if (cancelReasonId > 0) {
      setIsCancelDisableButton(false);
    } else {
      setIsCancelDisableButton(true);
    }
    setCancelReasonId(cancelReasonId);
    if (reason === CancelSubscriptionReasons.Other) {
      setCancelReasonOther(true);
    } else {
      setCancelReasonOther(false);
    }
  };

  const renderButton = () => {
    const isCancelledAndNotExpired =
      currentPlanDetails?.paymentSubscriptionStatusId ===
        PaymentSubscriptionStatus.Cancelled && !isPlusPlanExpired;

    if (isCancelledAndNotExpired) {
      return null;
    }

    return (
      <Button
        id={styles.upgradePlanBtnStyle}
        onClick={handleUpgradeAndChangePlan}
      >
        Upgrade Plan
      </Button>
    );
  };

  return (
    <>
      <div
        className={`${currentPlan === "Basic" ? styles.yourPlanBorder : ""}`}
      >
        <Row
          className={`${
            currentPlan === "Basic" ? styles.yourPlanContainerHeight : ""
          } ${styles.yourPlanContainer}`}
          gutter={[0, 15]}
        >
          <Col span={24} className={styles.yourPlanLabelText}>
            Your Plan
          </Col>
          <Col span={24}>
            <Row justify="space-between">
              <Col span={16} className={styles.wandaBasicText}>
                Wanda {currentPlan}
              </Col>
              {currentPlan === "Plus" ? (
                <Col span={8} className={styles.wandaBasicMonthText}>
                  ${Number(tripDetailsInfo.wandaSubscriptionCost).toFixed(2)}/mo
                </Col>
              ) : (
                <Col
                  span={8}
                  className={`${styles.wandaBasicMonthText} ${styles.wandaBasicFreeText}`}
                >
                  Free
                </Col>
              )}
              <Col span={24} className={styles.wandaPlusDateText}>
                {currentPlan === "Plus" && renderWandaPlusDates()}
              </Col>
              <Divider className={styles.divider} dashed />
            </Row>
          </Col>
          {currentPlan === "Basic" ? (
            <>
              <Col className={styles.basicTextContainer}>
                <Row>
                  <Col span={5} className={styles.wandaPlusImgContainer}>
                    {" "}
                    <img
                      className={styles.wandaPlusImg}
                      src={wandaPlusIcon}
                      alt="wandaplus"
                    />
                  </Col>
                  <Col span={19}>
                    <Col className={styles.wandaPlusHeading}>Wanda Plus</Col>
                    <Col className={styles.wandaBasicTextStyle}>
                      {" "}
                      Enjoy discounted rates on all our services - don’t miss
                      out!
                    </Col>
                  </Col>
                </Row>
              </Col>

              <Col span={24} className={styles.upgradeBtnContainer}>
                {renderButton()}
              </Col>
            </>
          ) : (
            <>
              <Row>
                <Col span={24}>
                  <Button
                    id={styles.changePlanBtnStyle}
                    onClick={handleUpgradeAndChangePlan}
                  >
                    Change Plan
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </Row>
      </div>
      <Modal
        visible={isChangePlanModalVisible}
        className={styles.changePlanModalContainer}
        width={"unset"}
        centered={true}
        footer={
          <Row justify="center" gutter={[15, 25]} className={styles.modalBtns}>
            <Col>
              <Button
                className={styles.modalCancelBtn}
                onClick={() => handleCancel("changePlan")}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className={`${styles.modalConfirmBtn} ${selectedPlan ===
                  currentPlan && styles.disableConfirmBtn}`}
                onClick={handleConfirm}
                disabled={selectedPlan === currentPlan}
              >
                Confirm
              </Button>
            </Col>
          </Row>
        }
      >
        <Row justify="center">
          <Col className={styles.planModalTitle}>Change Plan</Col>
        </Row>
        <Row justify="center" gutter={[30, 20]}>
          <Col>
            <PlanCard
              plan="Basic"
              selectedPlan={selectedPlan}
              handleCardClick={handleCardClick}
              wandaPlusDiscount={tripDetailsInfo.wandaPlusDiscount}
              wandaSubscriptionCost={tripDetailsInfo.wandaSubscriptionCost}
            />
          </Col>
          <Col>
            <PlanCard
              plan="Plus"
              selectedPlan={selectedPlan}
              handleCardClick={handleCardClick}
              wandaPlusDiscount={tripDetailsInfo.wandaPlusDiscount}
              wandaSubscriptionCost={tripDetailsInfo.wandaSubscriptionCost}
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        visible={isUseSavedCCModalVisible}
        className={styles.useSavedCCModalContainer}
        closable={true}
        closeIcon={<img src={crossMark} alt="close" />}
        onCancel={handleCloseUseSavedCCModal}
        width="unset"
        centered={true}
        footer={
          <>
            <div className={styles.paymentBasicContainer}>
              <Row justify="center" gutter={[10, 15]}>
                <Button
                  className={styles.useDifferentCardBtn}
                  onClick={handleUseDifferentCard}
                >
                  Use a Different Card
                </Button>
                <Button
                  className={styles.useSavedCardBtn}
                  onClick={() => handleUpgradePlus("SavedCard")}
                  loading={isLoading}
                >
                  Use Saved Card
                </Button>
              </Row>
              <Row justify="end" align="middle">
                <Col
                  className={`${commonStyles.cardInformation} ${styles.alignSavedCCInfo}`}
                >
                  {getCreditCardKindIcon(defaultCreditCard?.kind)}
                  &nbsp; **** {defaultCreditCard?.last4} &nbsp;
                  <span>
                    {" "}
                    Expires{" "}
                    {moment(defaultCreditCard?.expiresOn).format("MM/YYYY")}
                  </span>
                </Col>
              </Row>
            </div>
          </>
        }
      >
        <Row justify="center" className={styles.title}>
          How would you like to pay?
        </Row>
      </Modal>

      <Modal
        visible={isUpgradePlanVisible}
        className={styles.upgradePlanModalContainer}
        width={"unset"}
        centered={true}
        footer={
          <>
            <Row
              justify="center"
              gutter={[15, 20]}
              className={styles.creditFormBtns}
            >
              <Col>
                <Button
                  type="primary"
                  className={styles.creditFormCancelBtn}
                  onClick={() => handleCancel("creditCardForm")}
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  className={`${styles.creditFormUpgradeBtn} ${isLoading &&
                    styles.autoWidth} ${shouldDisableButton &&
                    styles.disableBtnOpacity}`}
                  onClick={() => handleUpgradePlus()}
                  disabled={shouldDisableButton}
                  loading={isLoading}
                >
                  Upgrade to Plus
                </Button>
              </Col>
            </Row>
            <Row justify="center">
              <Col className={styles.creditChargesText}>
                We'll charge your credit card monthly, cancel anytime.
              </Col>
            </Row>
          </>
        }
      >
        <Row justify="center">
          <Col span={24} className={styles.upgradePlanModalTitle}>
            Upgrade to Wanda Plus
          </Col>
          <Col span={24} className={styles.upgradePlanModalDescription}>
            ${tripDetailsInfo.wandaSubscriptionCost}/month
          </Col>
        </Row>

        <CreditCardForm
          ref={creditCardFormRef}
          form={form}
          isModalLayout={true}
          isValidCCState={isValidCCState}
          validateAndCheckForm={validateAndCheckForm}
        />
      </Modal>

      <Modal
        className={styles.welcomeWandaPlusModalContainer}
        visible={isWelcomeWandaPlusVisible}
        centered={true}
        width="unset"
        footer={
          <Row justify="center">
            <Col>
              <Button id={styles.letsGoBtn} onClick={handleLetsGo}>
                Let's Go!
              </Button>
            </Col>
          </Row>
        }
      >
        <Row justify="center">
          <Col>
            <img src={wandaPlusIcon} />
          </Col>
        </Row>
        <Row>
          <Col span={24} className={styles.welcomeWandaPlusModalTitle}>
            Welcome to Wanda Plus!
          </Col>
          <Col span={24} className={styles.welcomeWandaPlusModalDescription}>
            Enjoy 15% OFF transportation services.
          </Col>
          <Col span={24} className={styles.welcomeWandaPlusModalStatus}>
            Subscription renews on{" "}
            {formatUTCtoLocalDate(currentPlanDetails?.renewOn, "MMMM D, YYYY")}.
          </Col>
        </Row>
      </Modal>

      <Modal
        className={styles.cancelSubscriptionModalContainer}
        visible={isCancelSubscriptionModalVisible}
        centered={true}
        width="unset"
        footer={
          <Row
            justify="center"
            gutter={[15, 25]}
            className={styles.cancelSubscriptionModalBtns}
          >
            <Col>
              <Button
                className={styles.modalTakeMeBackBtn}
                onClick={() => handleCancel("NoTakeMeBack")}
              >
                No, Take Me Back
              </Button>
            </Col>
            <Col>
              <Button
                className={`${styles.yesCancelBtn} ${isCancelDisableButton &&
                  `${styles.disableConfirmBtn}`} ${isLoading &&
                  `${styles.autoWidth} ${styles.decreaseFontSize}`}`}
                onClick={handleCancelSubscription}
                loading={isLoading}
                disabled={isCancelDisableButton}
              >
                Yes, Cancel My Subscription
              </Button>
            </Col>
          </Row>
        }
      >
        <Form form={form} onValuesChange={handleValuesChange}>
          <Row gutter={[0, 15]}>
            <Col span={24} className={styles.cancelSubscriptionTitle}>
              Cancel Subscription
            </Col>
            <Col span={24} className={styles.cancelSubscriptionDescription}>
              Are you sure that you want to cancel your Wanda Plus subscription?
            </Col>
            <Col span={24} className={styles.cancelSubscriptionSubDescription}>
              If you cancel, you will continue to receive Wanda Plus benefits
              until{" "}
              {formatUTCtoLocalDate(
                currentPlanDetails?.validUntil || currentPlanDetails?.expiresOn,
                "MM/DD/YYYY"
              )}
              .
            </Col>
            {tripsAfterSubscriptionDate.length !== 0 && (
              <Col>
                <Row className={styles.cancelWarningContainer}>
                  <Col span={24}>
                    The services below are scheduled on dates after{" "}
                    {formatUTCtoLocalDate(
                      currentPlanDetails?.validUntil,
                      "MM/DD/YYYY"
                    )}
                    .
                  </Col>
                  <Col span={24}>
                    These services will be cancelled if you move forward.
                  </Col>
                  <Col xs={24} lg={0}>
                    <div className={styles.collapsibleMobileView}>
                      <CollapsibleTrips
                        dataSource={tripsAfterSubscriptionDate}
                      />
                    </div>
                  </Col>
                  <Col xs={0} lg={24}>
                    <DashBoardTable
                      dataSource={tripsAfterSubscriptionDate}
                      isCalling="YourPlan"
                      hideNoServiceMessage
                      hideDateSort
                    />
                  </Col>
                </Row>
              </Col>
            )}
            <Row
              className={
                tripsAfterSubscriptionDate.length > 0
                  ? styles.leftStyle
                  : styles.centerStyle
              }
            >
              <Col span={24} className={styles.cancelReasonTitle}>
                Cancellation Reason
              </Col>
              <Col span={24} className={styles.cancelReasonDropDown}>
                <Form.Item name="cancelReason">
                  <Select
                    placeholder="Select a reason"
                    className={styles.selectCancelReason}
                    options={subscriptionCancellationReasons}
                    suffixIcon={
                      <img
                        src={selectDropdownArrowIcon}
                        alt="select_reason_dropdown"
                      />
                    }
                  />
                </Form.Item>
              </Col>
              {isCancelReasonOther && (
                <div>
                  <Col span={24} className={styles.cancelReasonOtherTitle}>
                    Enter Comments
                  </Col>
                  <Col span={24} className={styles.cancelReasonComment}>
                    <Form.Item name="notes">
                      <TextArea
                        maxLength={250}
                        className={styles.commentTextBox}
                        rows={3}
                        placeholder="Enter comments"
                      />
                    </Form.Item>
                  </Col>
                </div>
              )}
            </Row>
          </Row>
        </Form>
      </Modal>

      <Modal
        className={styles.cancelledSubscriptionModal}
        visible={isCancelledSubscriptionModalVisible}
        centered={true}
        width="unset"
        footer={
          <Row justify="center">
            <Col>
              <Button id={styles.cancelledSubCloseBtn} onClick={handleClose}>
                Close
              </Button>
            </Col>
          </Row>
        }
      >
        <Row className={styles.cancelledSubSummary}>
          <Col span={24}>Your subscription has</Col>
          <Col span={24}>been canceled.</Col>
          <Col span={24}>
            Your Wanda Plus benefits will <br /> end on{" "}
            {formatUTCtoLocalDate(
              currentPlanDetails?.expiresOn,
              "MMMM D, YYYY"
            )}
            .
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default React.memo(YourPlan);
